import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../../services/Toast.service";
import {FileUploader, FileUploaderOptions, FileUploadModule} from "ng2-file-upload";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {LoadingService} from "../../../services/LoadingService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {VendorsService} from "../../../tpiq-services/vendors.service";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../../services/Session";
import {v4 as uuid} from 'uuid';
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {VendorStrategiesComponent} from "../vendor-strategies/vendor-strategies.component";
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import { environment } from '../../../../environments/environment';

declare let _: any;

@Component({
  selector: 'app-create-or-update-vendor',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, VendorStrategiesComponent, FroalaEditorModule, FileUploadModule],
  templateUrl: './create-or-update-vendor.component.html',
  styleUrl: './create-or-update-vendor.component.scss'
})
export class CreateOrUpdateVendorComponent implements OnInit, OnDestroy {
  user: any;
  org: string;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  vendor: any = {
    active: false,
  };
  editorOptions = {
    heightMin: 100,
    heightMax: 120,
    linkAlwaysBlank: true,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Enter vendor description here...',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey
  };
  allTaxStrategies: Array<any> = [];
  selectedStrategies: Array<any> = [];
  displayStrategies = true;
  uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  vendorIdForCreate: any;
  logoFiles = [];

  // New Ux changes
  @Input() editMode: any;
  @Input() vendorId: any;
  @Output() onCancelCreateOrUpdateOfVendor: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCreationOrUpdateOfVendor: EventEmitter<any> = new EventEmitter<any>();
  currentSection = 'vendorInfo';
  secReview = {
    'vendorInfo': false,
    'uploadResources': false
  };

  constructor(
    private loadingService: LoadingService,
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private vendorsService: VendorsService,
    private taxStrategyServices: ManageTaxStrategiesServices,
  ) {}

  ngOnInit() {
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.getTaxStrategies();
    if (this.vendorId) {
      this.editMode = true;
      this.setLogoUploader();
      this.getVendor();
      this.vendorIdForCreate = this.vendorId;
    } else{
      this.editMode = false;
      this.setLogoUploader();
      this.vendorIdForCreate = uuid();
      this.vendor = {
        active: false,
      };
    }

    this.switchBoard.onToastConfirm.pipe(takeUntil(this.destroy$)).subscribe(toast => {
      if (toast.data) {
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  getTaxStrategies() {
    const obj = {
      fromIndex: -1
    };
    this.loadingService.triggerLoadingEvent(true);
    this.taxStrategyServices.getPaginatedTaxStrategies(this.org, this.user, obj, null, null)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.allTaxStrategies = response.strategies;
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to get strategies data');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get strategies data');
        }
      });
  }

  getVendor() {
    this.loadingService.triggerLoadingEvent(true);
    this.vendorsService.getVendorData(this.org, this.user, this.vendorId)
      .subscribe((response) => {
        this.loadingService.triggerLoadingEvent(false);
        this.vendor = response;
        this.selectedStrategies = this.getFormatedData(response.strategies);
      }, (error) => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to get vendor data`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
  }

  getFormatedData(strategies) {
    const data = _.cloneDeep(strategies);
    _.each(data, (item) => {
      if (item.files) {
        item.files = JSON.parse(item.files);
        this.formatFiles();
      } else {
        item['files'] = [];
      }

      if (item.images) {
        item.images = JSON.parse(item.images);
      } else {
        item['images'] = [];
      }

      if (item.videos) {
        item.videos = JSON.parse(item.videos);
      } else {
        item['videos'] = [];
      }
    });

    return data;
  }

  formatFiles() {
    _.each(this.vendor.files, (file) => {
      const splitArray = file.name.split('.');
      if (splitArray[splitArray.length - 1] === 'pdf' || splitArray[splitArray.length - 1] === 'PDF') {
        file.fileType = 'pdf';
      } else if (this.isExcel(splitArray[splitArray.length - 1])) {
        file.fileType = 'excel';
      } else {
        file.fileType = '';
      }
    });
  }

  createOrEditVendor() {
    if (this.validateData()) {
      this.vendor.id = (!this.editMode) ? this.vendorIdForCreate : this.vendor.id;
      this.vendor.strategies = this.getFormatedStrategies();
      if (this.logoFiles.length > 0) {
        this.vendor.logo = this.logoFiles[0].link;
      }
      this.loadingService.triggerLoadingEvent(true);
      this.vendorsService.createOrEditVendor(this.org, this.user, this.vendor)
        .subscribe((response) => {
          this.loadingService.triggerLoadingEvent(false);
          const successMsg = (this.editMode) ? 'Vendor updated successfully' : 'Vendor created successfully';
          this.toastService.pop(TOAST_TYPE.success, successMsg);
          this.onCancelCreateOrUpdateOfVendor.emit();
          this.onCreationOrUpdateOfVendor.emit();
        }, (error) => {
          this.loadingService.triggerLoadingEvent(false);
          const message = error.message ? error.message : `Failed To create/update Vendor`;
          try {
            this.toastService.pop(TOAST_TYPE.error, message);
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, message);
          }
        });
    }
  }

  getFormatedStrategies() {
    const strategies = _.cloneDeep(this.selectedStrategies);
    _.each(strategies, (strategy) => {
      if (strategy.files) {
        strategy.files = (strategy.files && strategy.files.length > 0) ? JSON.stringify(strategy.files) : '';
      } else {
        strategy['files'] = '';
      }

      if (strategy.images) {
        strategy.images = (strategy.images && strategy.images.length > 0) ? JSON.stringify(strategy.images) : '';
      } else {
        strategy['images'] = '';
      }

      if (strategy.videos) {
        strategy.videos = (strategy.videos && strategy.videos.length > 0) ? JSON.stringify(strategy.videos) : '';
      } else {
        strategy['videos'] = '';
      }
    });
    return strategies;
  }

  onStrategySelect(strategy) {
    if (!_.isEmpty(strategy)) {
      const obj = {
        strategyId: strategy.id,
        strategyName: strategy.name,
        description: '',
        files: [],
        images: [],
        videos: [],
        offer: {
          offerType: 'price',
          offerValue: '',
          link: ''
        }
      };
      this.selectedStrategies.push(obj);
      this.selectedStrategies = _.uniqBy(this.selectedStrategies, 'strategyId');
      this.displayStrategies = false;
      setTimeout(() => {
        this.displayStrategies = true;
      });
    }
  }

  removeSelectedStrategy(index) {
    this.selectedStrategies.splice(index, 1);
  }

  fileDropOver($event){
    this.loadingService.triggerLoadingEvent(true);
    this.uploader.uploadAll();
  }

  fileOverBase($event){
    this.hasBaseDropZoneOver = $event;
  }

  setLogoUploader() {
    const base = this;
    const docUrl = this.taxStrategyServices.getFirmLogoUrl(this.org, this.user);
    this.uploader = new FileUploader({
      url: docUrl,
      headers: [{
        name: 'Authorization',
        value: 'Bearer ' + Session.getToken()
      }]
    } as FileUploaderOptions);
    this.uploader.onAfterAddingFile = file => {
      file.withCredentials = false;
    };
    this.uploader.onBuildItemForm = (fileItem: any, form: any) => {
      const payload: any = {};
      payload.sourceId = this.vendorIdForCreate;
      payload.sourceType = 'vendor_logo';
      if (fileItem.file && fileItem.file.size){
        payload.fileSize = fileItem.file.size;
      }
      form.append('payload', JSON.stringify(payload));
    };
    this.uploader.onCompleteItem = (item, response, status, header) => {
      this.loadingService.triggerLoadingEvent(false);
      if (status === 200) {
        this.uploader.progress = 100;
        const document: any = JSON.parse(response);
        if (document) {
          let obj = {};
          obj['id'] = document.id;
          obj['name'] = document.name;
          obj['link'] = document.temporaryURL;
          this.logoFiles = [];
          this.logoFiles.push(obj);
        }
      } else {
        this.resetUploader();
        this.toastService.pop(TOAST_TYPE.error, 'Failed to upload logo');
      }
    };
  }

  resetUploader() {
    this.uploader.queue.forEach((item) => {
      item.remove();
    });
  }

  deleteDocumentFile(file, index){
    this.logoFiles.splice(index, 1);
  }

  // New Ux changes
  moveToSection(sectionName) {
    this.currentSection = sectionName;

    if(sectionName === 'uploadResources') {
      this.secReview.vendorInfo = true;
      this.secReview.uploadResources = false;
    } else if(sectionName === 'vendorInfo') {
      this.secReview.vendorInfo = false;
      this.secReview.uploadResources = false;
    }
  }

  goToNextSection(section?) {
    this.currentSection = section;
    this.secReview.vendorInfo = true;
  }

  goToPreviousSection(section?) {
    this.currentSection = section;

    if(section === 'vendorInfo') {
      this.secReview.uploadResources = false;
      this.secReview.vendorInfo = false;
    }
  }

  closeCreatePopup() {
    this.onCancelCreateOrUpdateOfVendor.emit();
  }

  setVendorStatus(type) {
    if (type === 'yes') {
      this.vendor.active = true;
    } else if (type === 'no') {
      this.vendor.active = false;
    }
  }

  isExcel(extension){
    const types = ['xls', 'xlsx', 'xlsm', 'xlsb', 'xltx', 'xltm', 'xlt', 'xltm', 'xltm', 'xltm'];
    if (types.indexOf(extension.toLowerCase()) !== -1) {
      return true;
    }else {
      return false;
    }
  }

  validateData(){
    if (!this.vendor.contactFirstName){
      this.toastService.pop(TOAST_TYPE.error, 'Enter First Name');
      return false;
    } else if (!this.vendor.contactLastName){
      this.toastService.pop(TOAST_TYPE.error, 'Enter Last Name');
      return false;
    } else if (!this.vendor.name){
      this.toastService.pop(TOAST_TYPE.error, 'Enter business/vendor name');
      return false;
    }
    return true;
  }

}
